import React, { useEffect, useRef, useState } from 'react'
import { MdPlaylistAddCheck } from 'react-icons/md'
import { FaArrowUpLong } from 'react-icons/fa6'

export default function OnboardingNav({ menuItems, topRef, offsetMargin }) {
  const [activeIndex, setActiveIndex] = useState(0)
  const observerRef = useRef(null)
  const [intersectionMargin, setIntersectionMargin] =
    useState('0px 0px -60% 0px') // triggers when top 40% of section is visible

  useEffect(() => {
    setIntersectionMargin(offsetMargin)
    const observerOptions = {
      root: null, // viewport
      rootMargin: intersectionMargin,
      threshold: 0
    }

    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = menuItems.findIndex(
            (item) => item.ref.current === entry.target
          )
          if (index !== -1) setActiveIndex(index)
        }
      })
    }, observerOptions)

    // Observe each section
    menuItems.forEach((item) => {
      if (item.ref?.current) {
        observerRef.current.observe(item.ref.current)
      }
    })

    // Cleanup observer on unmount
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }
    }
  }, [menuItems, offsetMargin])

  const scrollToSection = (ref, index) => {
    if (ref.current === topRef.current && activeIndex === 0) {
      return
    }
    setActiveIndex(index)
    ref.current?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div>
      <h5 className='mb-4 flex items-center gap-2 font-alpha-family text-alpha-black text-base'>
        <MdPlaylistAddCheck size={30} className='shrink-0' />
        <span className='break-words'>
          {$localize`:onboarding.description|Onboarding Description - On This Page@@onboardingOnThisPage:On this page`}
        </span>
      </h5>

      <div className='relative pl-4'>
        <ul className='list-none flex flex-col gap-3'>
          {menuItems.map((item, index) => (
            <li
              key={index}
              className='relative cursor-pointer text-sm pl-4'
              onClick={() => scrollToSection(item.ref, index)}
            >
              <div
                className={`absolute -left-[10px] top-1 w-[2px] h-[3rem] ${
                  activeIndex === index ? 'bg-blue-600' : 'bg-gray-400'
                }`}
              />

              <span
                className={`transition-colors ${
                  activeIndex === index
                    ? 'text-blue-600 font-semibold'
                    : 'text-gray-800'
                }`}
              >
                <span className='text-sm'>{item.name}</span>
              </span>
            </li>
          ))}
        </ul>
      </div>

      <div className='mt-12'>
        <span
          onClick={() => scrollToSection(topRef, null)}
          className='flex cursor-pointer items-center gap-4 text-base font-semibold text-black hover:underline'
          aria-label='Back to top'
        >
          <FaArrowUpLong size={20} /> Back to Top
        </span>
      </div>
    </div>
  )
}
